export default function Wrapper({ children }) {
  return (
    <div className="vh-100 d-flex align-items-start flex-column">
      {children}
    </div>
  );
}